import React, { useState, useEffect } from "react";
import { ImageSlot } from "./ImageSlot";
import { lock, unlock } from "./scrollLock";
import { X } from "lucide-react";

const PRODUCTS = [
  {
    id: "goldbar-600",
    brand: "Gold Bar",
    name: "Gold Bar 600",
    puffs: "600",
    badge: "600 PUFFS",
    spec: "Disposable",
    description:
      "Ideal for both beginners and experienced users, this device requires no refill, replacements or maintenance. Simply open and enjoy. Its compact and portable design makes it perfect for vaping on the go while maintaining premium performance.",
    image:
      "https://customer-assets.emergentagent.com/job_vape-distribution-za/artifacts/zpvj94cf_Gold%20Bar%20600.png",
    flavourMode: "gallery",
    flavours: [
      "Banana Ice",
      "Blue Raspberry",
      "Cherry Fizz",
      "Grape Ice",
      "Kiwi Passion Guava",
      "Lemon Lime",
      "Peach Mango Watermelon",
      "Strawberry Peach",
      "Watermelon Ice",
    ],
    flavourImages: {
      "Banana Ice":
        "https://customer-assets.emergentagent.com/job_vape-distribution-za/artifacts/6y24qjpy_Banana%20Ice.jpg",
      "Blue Raspberry":
        "https://customer-assets.emergentagent.com/job_vape-distribution-za/artifacts/y0l9umhb_Blue%20Raspberry.jpg",
      "Cherry Fizz":
        "https://customer-assets.emergentagent.com/job_vape-distribution-za/artifacts/ab15ndgv_Cherry%20Fizz.jpg",
      "Grape Ice":
        "https://customer-assets.emergentagent.com/job_vape-distribution-za/artifacts/14jdafvb_Grape%20Ice.jpg",
      "Kiwi Passion Guava":
        "https://customer-assets.emergentagent.com/job_vape-distribution-za/artifacts/m14s0ka4_Kiwi%20Passion%20Guava.jpg",
      "Lemon Lime":
        "https://customer-assets.emergentagent.com/job_vape-distribution-za/artifacts/cfimsnae_Lemon%20Lime.jpg",
      "Peach Mango Watermelon":
        "https://customer-assets.emergentagent.com/job_vape-distribution-za/artifacts/vn0tet82_Peach%20Mango%20Watermelon.jpg",
      "Strawberry Peach":
        "https://customer-assets.emergentagent.com/job_vape-distribution-za/artifacts/1pa62qkz_Strawberry%20Peach.jpg",
      "Watermelon Ice":
        "https://customer-assets.emergentagent.com/job_vape-distribution-za/artifacts/ia10ffa3_Watermelon%20Ice.jpg",
    },
  },
  {
    id: "goldbar-247",
    brand: "Gold Bar",
    name: "Gold Bar 247",
    puffs: "12 000",
    badge: "12 000 PUFFS",
    spec: "Rechargeable · USB-C",
    description:
      "Upgrade your Gold Bar experience to the Gold Bar 247 that can deliver up to 12 000 puffs. This comfortable hold device is rechargeable with a USB-C point and is designed for long lasting and reliable performance.",
    image:
      "https://customer-assets.emergentagent.com/job_vape-distribution-za/artifacts/15g66cdx_Gold%20Bar%20247.png",
    flavourMode: "gallery",
    flavours: [
      "Banana Ice",
      "Blue Raspberry",
      "Blue Sour Razz",
      "Cherry Fizz",
      "Grape Ice",
      "Hawaiian Sunrise",
      "Kiwi Passion Guava",
      "Strawberry Cheesecake",
      "Strawberry Raspberry Cherry",
      "Watermelon Ice",
    ],
    flavourImages: {
      "Banana Ice":
        "https://customer-assets.emergentagent.com/job_vape-distribution-za/artifacts/jvzfgzt1_BANANA%20ICE.jpg",
      "Blue Raspberry":
        "https://customer-assets.emergentagent.com/job_vape-distribution-za/artifacts/aqzxpdd2_BLUE%20RASPBERRY.jpg",
      "Blue Sour Razz":
        "https://customer-assets.emergentagent.com/job_vape-distribution-za/artifacts/1lzc7v1n_BLUE%20SOUR%20RAZZ.jpg",
      "Cherry Fizz":
        "https://customer-assets.emergentagent.com/job_vape-distribution-za/artifacts/vl3pcdxv_CHERRY%20FIZZ.jpg",
      "Grape Ice":
        "https://customer-assets.emergentagent.com/job_vape-distribution-za/artifacts/b2nxshej_GRAPE%20ICE.jpg",
      "Hawaiian Sunrise":
        "https://customer-assets.emergentagent.com/job_vape-distribution-za/artifacts/tkutjv9z_HAWAIIAN%20SUNRISE.jpg",
      "Kiwi Passion Guava":
        "https://customer-assets.emergentagent.com/job_vape-distribution-za/artifacts/tplxpwp5_KIWI%20PASSION%20GUAVA.jpg",
      "Strawberry Cheesecake":
        "https://customer-assets.emergentagent.com/job_vape-distribution-za/artifacts/91oq998v_STRAWBERRY%20GHEESECAKE.jpg",
      "Strawberry Raspberry Cherry":
        "https://customer-assets.emergentagent.com/job_vape-distribution-za/artifacts/l85ww4wp_STRAWBERRY%20RASPBERRY%20CHERRY.jpg",
      "Watermelon Ice":
        "https://customer-assets.emergentagent.com/job_vape-distribution-za/artifacts/3bmwy6ud_WATERMELON%20ICE.jpg",
    },
  },
  {
    id: "titan-pro",
    brand: "Titan Pro",
    name: "Titan Pro",
    puffs: "15 000",
    badge: "15 000 PUFFS",
    spec: "Replaceable Pods · USB-C",
    description:
      "Enjoy a smooth and refreshing vape experience with the Titan Pro. Designed for convenience and long-lasting performance, this sleek all-in-one device delivers up to 15 000 puffs. The Titan Pro also comes with replaceable pods so you can experience different flavours on the same device.",
    image:
      "https://customer-assets.emergentagent.com/job_vape-distribution-za/artifacts/9fj16etr_Titan%20Pro%20Starter.png",
    flavourMode: "gallery",
    flavours: [
      "Blue Raspberry",
      "Blue Sour Razz",
      "Cherry Fizz",
      "Cola Freeze",
      "Grape Ice",
      "Juicy Peach",
      "Lemon Lime",
      "Pineapple Ice",
      "Strawberry Raspberry Cherry",
      "Triple Berries",
    ],
    flavourImages: {
      "Blue Raspberry":
        "https://customer-assets.emergentagent.com/job_vape-distribution-za/artifacts/7sh7kxm2_blue-raspberry.jpg",
      "Blue Sour Razz":
        "https://customer-assets.emergentagent.com/job_vape-distribution-za/artifacts/ptquqcrn_BLUEBERRY-SOUR-RAZZ.jpg",
      "Cherry Fizz":
        "https://customer-assets.emergentagent.com/job_vape-distribution-za/artifacts/ta15pwnj_CHERRY-FIZZ.jpg",
      "Cola Freeze":
        "https://customer-assets.emergentagent.com/job_vape-distribution-za/artifacts/aca1a2de_COLA-FREEZE.jpg",
      "Grape Ice":
        "https://customer-assets.emergentagent.com/job_vape-distribution-za/artifacts/nnsx22cn_GRAPE-ICE.jpg",
      "Juicy Peach":
        "https://customer-assets.emergentagent.com/job_vape-distribution-za/artifacts/hvgpmyrb_JUICY-PEACH.jpg",
      "Lemon Lime":
        "https://customer-assets.emergentagent.com/job_vape-distribution-za/artifacts/i39zm49o_LEMON-LIME.jpg",
      "Pineapple Ice":
        "https://customer-assets.emergentagent.com/job_vape-distribution-za/artifacts/dhmkpi9r_PINEAPPLE-ICE.jpg",
      "Strawberry Raspberry Cherry":
        "https://customer-assets.emergentagent.com/job_vape-distribution-za/artifacts/jjg2a565_STRAWBERRY-RASPBERRY-CHERRY.jpg",
      "Triple Berries":
        "https://customer-assets.emergentagent.com/job_vape-distribution-za/artifacts/impexs4e_Triple-Berries.jpg",
    },
  },
  {
    id: "titan-pro-pod",
    brand: "Titan Pro",
    name: "Titan Pro Pod",
    puffs: "15 000",
    badge: "REFILL POD",
    spec: "Replacement Pod · 15K",
    description:
      "These pods are designed to be used on the Titan Pro device. For a more affordable option you simply get the flavour you want and use your current Titan Pro device, giving you an all-in-one experience. They are easy to replace and go with any Titan Pro device.",
    image:
      "https://customer-assets.emergentagent.com/job_vape-distribution-za/artifacts/x5dho5q6_Titan%20Pod.png",
    flavourMode: "gallery",
    flavours: [
      "Blue Raspberry",
      "Blue Sour Razz",
      "Cherry Fizz",
      "Cola Freeze",
      "Grape Ice",
      "Juicy Peach",
      "Lemon Lime",
      "Pineapple Ice",
      "Strawberry Raspberry Cherry",
      "Triple Berries",
    ],
    flavourImages: {
      "Blue Raspberry":
        "https://customer-assets.emergentagent.com/job_vape-distribution-za/artifacts/nloqc8kt_BLUE-RASPBERRY.jpg",
      "Blue Sour Razz":
        "https://customer-assets.emergentagent.com/job_vape-distribution-za/artifacts/t54afc4h_BLUEBERRY-SOUR-RAZZ.jpg",
      "Cherry Fizz":
        "https://customer-assets.emergentagent.com/job_vape-distribution-za/artifacts/fhmjad86_CHERRY-FIZZ.jpg",
      "Cola Freeze":
        "https://customer-assets.emergentagent.com/job_vape-distribution-za/artifacts/uric5cho_COLA-FREEZE.jpg",
      "Grape Ice":
        "https://customer-assets.emergentagent.com/job_vape-distribution-za/artifacts/khlgrgsh_GRAPE-ICE.jpg",
      "Juicy Peach":
        "https://customer-assets.emergentagent.com/job_vape-distribution-za/artifacts/58f16pv5_JUICY-PEACH.jpg",
      "Lemon Lime":
        "https://customer-assets.emergentagent.com/job_vape-distribution-za/artifacts/qsz5v9lk_LEMON-LIME.jpg",
      "Pineapple Ice":
        "https://customer-assets.emergentagent.com/job_vape-distribution-za/artifacts/8rclkzt8_PINEAPPLE-ICE.jpg",
      "Strawberry Raspberry Cherry":
        "https://customer-assets.emergentagent.com/job_vape-distribution-za/artifacts/m4n9nm4q_STRAWBERRY-RASPBERRY-CHERRY.jpg",
      "Triple Berries":
        "https://customer-assets.emergentagent.com/job_vape-distribution-za/artifacts/80y45cuj_Triple-Berries.jpg",
    },
  },
];

const ProductCard = ({ product, onOpen }) => (
  <article
    className="relative flex flex-col bg-misty-surface border border-white/5 transition-all duration-300 hover:border-misty-steel/50 overflow-hidden group"
    data-testid={`product-card-${product.id}`}
  >
    <div className="relative">
      <ImageSlot
        ratio="aspect-[4/5]"
        label={`${product.name} Photo`}
        src={product.image}
        alt={product.name}
        className="!bg-misty-base"
        testId={`product-image-${product.id}`}
      />
      <div className="absolute top-4 left-4 z-10 bg-misty-steel text-misty-base px-3 py-1.5 text-[10px] tracking-[0.2em] font-sans font-semibold uppercase">
        {product.badge}
      </div>
    </div>
    <div className="p-6 sm:p-8 flex flex-col gap-4 flex-1">
      <p className="text-misty-steel text-[10px] tracking-[0.4em] uppercase font-sans">
        {product.brand}
      </p>
      <h3
        className="font-display text-2xl sm:text-3xl text-misty-text tracking-wide leading-none"
        data-testid={`product-name-${product.id}`}
      >
        {product.name}
      </h3>
      <div className="flex items-baseline gap-3 border-b border-white/5 pb-4 flex-wrap">
        <span className="font-display text-3xl text-misty-steelHi tracking-wide whitespace-nowrap">
          {product.puffs}
        </span>
        <span className="text-misty-dim text-[10px] tracking-[0.3em] uppercase">
          Puffs · {product.spec}
        </span>
      </div>
      <p className="text-misty-muted text-sm leading-relaxed flex-1">
        {product.description}
      </p>
      <button
        onClick={() => onOpen(product)}
        className="mt-2 border border-white/15 hover:border-misty-steel hover:bg-misty-steel/10 text-misty-text hover:text-misty-steel px-6 py-3.5 font-sans tracking-[0.2em] uppercase text-[11px] transition-all"
        data-testid={`view-flavours-${product.id}`}
      >
        View Flavours →
      </button>
    </div>
  </article>
);

const FlavourModal = ({ product, onClose }) => {
  useEffect(() => {
    if (!product) return undefined;
    const onKey = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onKey);
    lock("flavour-modal");
    return () => {
      document.removeEventListener("keydown", onKey);
      unlock("flavour-modal");
    };
  }, [product, onClose]);

  if (!product) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-8 bg-misty-base/90 backdrop-blur-md overflow-y-auto"
      data-testid="flavour-modal-overlay"
      onClick={onClose}
    >
      <div
        className="relative bg-misty-surface border border-white/10 w-full max-w-4xl my-8 max-h-[90vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
        data-testid="flavour-modal-content"
      >
        <button
          onClick={onClose}
          className="absolute top-4 right-4 z-10 text-misty-muted hover:text-misty-text transition-colors p-2"
          data-testid="flavour-modal-close"
          aria-label="Close"
        >
          <X size={20} />
        </button>
        <div className="p-8 sm:p-12 flex flex-col gap-8">
          <div className="flex flex-col gap-3">
            <p className="text-misty-steel text-[10px] tracking-[0.4em] uppercase">
              {product.brand} · Flavours
            </p>
            <h3 className="font-display text-4xl sm:text-5xl text-misty-text tracking-wide leading-none">
              {product.name}
            </h3>
            <div className="w-10 h-px bg-misty-steel/60" />
          </div>

          {product.flavourMode === "gallery" ? (
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
              {product.flavours.map((f) => (
                <div
                  key={f}
                  className="flex flex-col gap-3"
                  data-testid={`flavour-${product.id}-${f
                    .toLowerCase()
                    .replace(/\s+/g, "-")}`}
                >
                  <ImageSlot
                    ratio="aspect-square"
                    label={f}
                    src={product.flavourImages?.[f]}
                    alt={`${product.name} — ${f}`}
                    className="!bg-misty-base"
                  />
                  <p className="text-misty-text text-xs sm:text-sm font-sans tracking-wide text-center">
                    {f}
                  </p>
                </div>
              ))}
            </div>
          ) : (
            <div className="flex flex-wrap gap-3">
              {product.flavours.map((f) => (
                <div
                  key={f}
                  className="inline-flex items-center gap-2.5 bg-misty-base border border-white/10 px-4 py-2.5 hover:border-misty-steel/40 transition-colors"
                  data-testid={`flavour-${product.id}-${f
                    .toLowerCase()
                    .replace(/\s+/g, "-")}`}
                >
                  <span className="w-1.5 h-1.5 rounded-full bg-misty-steel" />
                  <span className="text-misty-text text-sm font-sans">{f}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export const Products = () => {
  const [active, setActive] = useState(null);

  return (
    <section
      id="products"
      className="relative py-16 sm:py-20 px-6 md:px-12 bg-gradient-to-b from-misty-base via-misty-surface/30 to-misty-base"
      data-testid="products-section"
    >
      <div className="max-w-[1400px] mx-auto flex flex-col gap-10">
        <div className="flex flex-col gap-4 max-w-2xl">
          <p className="text-misty-steel text-[10px] sm:text-xs tracking-[0.5em] uppercase font-sans">
            Our Range
          </p>
          <h2 className="font-display text-5xl sm:text-6xl lg:text-7xl text-misty-text tracking-wide leading-[0.95]">
            Products
          </h2>
          <div className="w-16 h-px bg-misty-steel/60 mt-2" />
          <p className="text-misty-muted leading-relaxed text-base sm:text-lg max-w-3xl mt-2">
            Explore our various options of Gold Bar and Titan vapes. From
            disposable to rechargeable options, there is a vape for everyone. A
            variety of flavours to explore will ensure you have a luxurious
            experience with every puff. Enjoy!
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {PRODUCTS.map((p) => (
            <ProductCard key={p.id} product={p} onOpen={setActive} />
          ))}
        </div>
      </div>
      <FlavourModal product={active} onClose={() => setActive(null)} />
    </section>
  );
};
